import React, { createContext, useContext, useState } from "react";

const DividendNotificationContext = createContext();

export const DividendNotificationProvider = ({ children }) => {
  const [dividendNotification, setDividendNotification] = useState(0);

  return (
    <DividendNotificationContext.Provider value={{ dividendNotification, setDividendNotification }}>
      {children}
    </DividendNotificationContext.Provider>
  );
};

export const useDividendNotification = () => useContext(DividendNotificationContext);
